"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHeaderPathValidator = void 0;
//Matches file paths to any valid format. Matches both "\" and "/" as valid separators in file path.
//Extension ("[h]+") checks specifically for '.h' and can be extende to any if required.
//Does NOT match relative file paths.
var pathRegex = "^(([a-zA-Z]:)|((?:\\\\|.\\/?){1,2}\\w+)\\$?)((\\\\|\\/)(\\w[\\w ]*.*))+\\.([h]+)$";
var errorMessage = "Must be valid header path.";
var pathPattern = {
    pattern: pathRegex,
};
exports.getHeaderPathValidator = function () { return ({
    getRjsfValidation: function () { return pathPattern; },
    getCustomErrorMessage: function () { return errorMessage; },
    getValidation: function () { return ({
        name: "pattern",
        message: exports.getHeaderPathValidator().getCustomErrorMessage(),
    }); },
}); };
